<!--
 * @description: 公司信息 联系我们
 * @Author: Jay
 * @Date: 2021-09-24 14:25:25
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-19 15:55:29
-->
<template>
  <div>
    <div class="info-code box-shadow flex">
      <!-- log图片 -->
      <el-image
        class="code-left"
        :src="$api + infoData.lianxi"
        fit="fill"
        :lazy="true"
      ></el-image>
      <!-- 公司信息 -->
      <div class="padding code-right">
        <p class="right-p">
          <span class="font_weight_bold">地址：</span>
          <span class="text-gray padding-left-xs">
            {{ infoData[0].value }}
          </span>
        </p>
        <p class="right-p">
          <span class="font_weight_bold text-black">邮编：</span>
          <span class="text-gray padding-left-xs">
            {{ infoData[1].value }}</span
          >
        </p>
        <p class="right-p">
          <span class="font_weight_bold text-black">办公电话：</span>
          <span class="text-gray padding-left-xs">
            {{ infoData[2].value }}</span
          >
        </p>
        <p class="right-p">
          <span class="font_weight_bold text-black">电子邮件：</span>
          <span class="text-gray padding-left-xs">
            {{ infoData[3].value }}</span
          >
        </p>
        <p class="right-p">
          <span class="font_weight_bold">公司传真：</span>
          <span class="text-gray padding-left-xs">
            {{ infoData[4].value }}</span
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "firmInfoCode",
  props: ["infoData"],
  data() {
    return {
      usData: [],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.info-code {
  width: 1200px;
  height: 280px;

  background-color: #ffffff;
}
.code-left {
  width: 50%;
  height: 100%;
}

.code-right {
  width: 50%;
  height: 100%;
  font-size: 18px;
  //   box-sizing: border-box;
  .right-p {
    height: 38px;
    line-height: 38px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>